import React from 'react';
import PropTypes from 'prop-types';

import { Offer, ButtonsGroup } from '../../components';
import {
  Badge, Icon, Loader, Select, Input, Confirm, Modal, Button, TextArea
} from '../../ui-kit';

import './styles.scss';

const OffersView = (props) => (
  <>
    <Confirm
      title="Deleting photo"
      subtitle="Do you want to delete this photo?"
      visible={props.deletePhotoConfirm.visible}
      onClose={!props.saveChangesLoading && props.handleDeletePhotoConfirmClose}
      onSubmit={props.deletePhoto}
      loading={props.saveChangesLoading}
    />
    <Confirm
      title={props.castingActionConfirm.title}
      subtitle={props.castingActionConfirm.subtitle}
      visible={props.castingActionConfirm.visible}
      onClose={props.handleActionsConfirmClose}
      onSubmit={() => props.castingActionConfirm.onSubmit(props.castingActionConfirm)}
      loading={props.saveChangesLoading}
    />
    <Modal
      title="Edit casting"
      visible={props.editModal.visible}
      onClose={!props.saveChangesLoading && props.handleModalClose}
    >
      <Input 
        value={props.editModal.title} 
        placeholder="Casting name" 
        onChange={(e) => props.setEditModal({ ...props.editModal, title: e.target.value, hasChanges: true })} 
        disabled={props.saveChangesLoading}
        maxLength={46}
      />
      <TextArea 
        value={props.editModal.description} 
        placeholder="Casting description" 
        onChange={(e) => props.setEditModal({ ...props.editModal, description: e.target.value, hasChanges: true })} 
        disabled={props.saveChangesLoading}
        maxLength={4096}
      />
      <div className="modal-buttons">
        <Button 
          value="Save" 
          onClick={props.editCasting} 
          disabled={!props.editModal.hasChanges || !props.editModal.title.trim().length || !props.editModal.description.trim().length}
          loading={props.saveChangesLoading}
        />
        <Button 
          value="Cancel" 
          onClick={props.handleModalClose} 
          type="secondary" 
          disabled={props.saveChangesLoading || !props.editModal.title.trim().length || !props.editModal.description.trim().length}
        />
      </div>
    </Modal>
    <ButtonsGroup
      loading={props.moderatedCastings.loading
        || props.allCastings.loading
        || props.declinedCastings.loading
        || props.updateDataLoading
        || props.categories.loading}
      activeTabIndex={props.activeTab}
      badges={[
        {
          name: 'Castings awaiting moderation',
          separator: true,
        },
        {
          name: 'All castings',
        },
        {
          name: 'Archived castings',
        },
        {
          name: 'Declined castings',
        },
      ]}
      setActiveTab={(index) => props.setActiveTab(index)}
      refreshAction={() => props.refreshAction()}
    />
    <div className="offers_sort_container">
      <Badge
        value="Sort by registration date"
        onClick={() => props.sortCastingsList(props.directionRenderStr(), props.category)}
        rightArrow={(
          <div className="badge_short_arrow">
            <Icon name={`arrow-${props.directionStr === 'desc' || !props.directionStr
              ? 'up'
              : 'down'}-short`}
            />
          </div>
        )}
        disabled={props.moderatedCastings.loading
          || props.allCastings.loading
          || props.declinedCastings.loading
          || props.updateDataLoading
          || props.categories.loading}
      />
      <Select
        options={[
          { key: 0, label: 'All castings', value: '' },
          { key: 1, label: 'Media & Art', value: 'Media & Art' },
          { key: 2, label: 'Hospitality', value: 'Hospitality' },
          { key: 3, label: 'Beauty', value: 'Beauty' },
          { key: 4, label: 'Service', value: 'Service' },
          { key: 5, label: 'Digital & Media', value: 'Digital & Media' },
          { key: 6, label: 'Entertainment', value: 'Entertainment' },
          { key: 7, label: 'Sports & Education', value: 'Sports & Education' },
          { key: 8, label: 'Model business', value: 'Model business' },
          { key: 9, label: 'Music', value: 'Music' },
          { key: 10, label: 'Other', value: 'Other' },
          
          // { key: 0, label: 'All castings', value: '' },
          // { key: 1, label: 'Modeling business', value: 'Modeling business' },
          // { key: 2, label: 'Music', value: 'Music' },
          // { key: 3, label: 'Hospitality', value: 'Hospitality' },
          // { key: 4, label: 'Service', value: 'Service' },
          // { key: 5, label: 'Entertainment', value: 'Entertainment' },
        ]}
        value={props.category}
        setValue={props.setCategory}
        onChange={(newValue) => props.sortCastingsList(props.directionStr, newValue)}
        disabled={props.moderatedCastings.loading
          || props.allCastings.loading
          || props.declinedCastings.loading
          || props.updateDataLoading
          || props.categories.loading}
      />
    </div>
    {props.moderatedCastings.loading || props.allCastings.loading || props.categories.loading ? (
      <div className="offer_page_loader__block">
        <Loader type="big-loader" />
      </div>
    ) : (
      <div className={`offers_list__container ${props.updateDataLoading ? 'offers_list_blured' : ''}`}>
        {props.activeTab === 0
          && props.moderatedCastings.success
          && props.moderatedCastings.data
          && props.moderatedCastings.data.map((item) => (
            <Offer
              name={item.title}
              description={item.description}
              status={item.status}
              dueDate={item.contract.dueDate}
              currency={item.contract.currency}
              payment={item.contract.amount}
              creatorId={item.creatorId}
              gender={item.gender}
              location={item.place}
              id={item.castingId}
              image={item.avatar?.uri}
              age={item.age}
              type={item.contract.type}
              photos={item.photos}
              sphere={props.renderSphereObject(item.mainCategory)}
              category={props.renderCategoriesObject(props.renderSphereObject(item.mainCategory), item.category)}
              requirements={item.requirements}
              acceptCasting={(id) => props.acceptCasting(id, 'del')}
              declineCasting={(id) => props.declineCasting(id, 'del')}
              handleDeletePhotoConfirmOpen={props.handleDeletePhotoConfirmOpen}
              handleDeleteCastingConfirmOpen={props.handleDeleteCastingConfirmOpen}
              handleModalOpen={props.handleModalOpen}
              handleActionsConfirmOpen={props.handleActionsConfirmOpen}
              createdTime={item.createdTime}
            />
          ))}
        {props.activeTab === 1
          && props.allCastings.success
          && props.allCastings.data
          && props.allCastings.data.map((item) => (
            <Offer
              creatorId={item.creatorId}
              name={item.title}
              description={item.description}
              status={item.status}
              dueDate={item.contract.dueDate}
              currency={item.contract.currency}
              payment={item.contract.amount}
              feedbacks={item.feedbacks}
              views={item.review}
              gender={item.gender}
              location={item.place}
              id={item.castingId}
              image={item.avatar?.uri}
              age={item.age}
              type={item.contract.type}
              photos={item.photos}
              sphere={props.renderSphereObject(item.mainCategory)}
              category={props.renderCategoriesObject(props.renderSphereObject(item.mainCategory), item.category)}
              requirements={item.requirements}
              acceptCasting={(id) => props.acceptCasting(id)}
              declineCasting={(id) => props.declineCasting(id)}
              handleDeletePhotoConfirmOpen={props.handleDeletePhotoConfirmOpen}
              handleDeleteCastingConfirmOpen={props.handleDeleteCastingConfirmOpen}
              handleModalOpen={props.handleModalOpen}
              handleActionsConfirmOpen={props.handleActionsConfirmOpen}
              createdTime={item.createdTime}
            />
          ))}
        {props.activeTab === 2
          && props.archivedCastings.success
          && props.archivedCastings.data
          && props.archivedCastings.data.map((item) => (
            <Offer
              creatorId={item.creatorId}
              name={item.title}
              description={item.description}
              status={item.status}
              dueDate={item.contract.dueDate}
              currency={item.contract.currency}
              payment={item.contract.amount}
              feedbacks={item.feedbacks}
              views={item.review}
              gender={item.gender}
              location={item.place}
              id={item.castingId}
              image={item.avatar?.uri}
              age={item.age}
              type={item.contract.type}
              photos={item.photos}
              sphere={props.renderSphereObject(item.mainCategory)}
              category={props.renderCategoriesObject(props.renderSphereObject(item.mainCategory), item.category)}
              requirements={item.requirements}
              acceptCasting={(id) => props.acceptCasting(id)}
              declineCasting={(id) => props.declineCasting(id)}
              handleDeletePhotoConfirmOpen={props.handleDeletePhotoConfirmOpen}
              handleDeleteCastingConfirmClose={props.handleDeleteCastingConfirmClose}
              handleDeleteCastingConfirmOpen={props.handleDeleteCastingConfirmOpen}
              handleModalOpen={props.handleModalOpen}
              handleActionsConfirmOpen={props.handleActionsConfirmOpen}
              createdTime={item.createdTime}
            />
          ))}
        {props.activeTab === 3
          && props.declinedCastings.success
          && props.declinedCastings.data
          && props.declinedCastings.data.map((item) => (
            <Offer
              creatorId={item.creatorId}
              name={item.title}
              description={item.description}
              status={item.status}
              dueDate={item.contract.dueDate}
              currency={item.contract.currency}
              payment={item.contract.amount}
              feedbacks={item.feedbacks}
              views={item.review}
              gender={item.gender}
              location={item.place}
              id={item.castingId}
              image={item.avatar?.uri}
              age={item.age}
              type={item.contract.type}
              photos={item.photos}
              sphere={props.renderSphereObject(item.mainCategory)}
              category={props.renderCategoriesObject(props.renderSphereObject(item.mainCategory), item.category)}
              requirements={item.requirements}
              acceptCasting={(id) => props.acceptCasting(id)}
              declineCasting={(id) => props.declineCasting(id)}
              createdTime={item.createdTime}
              handleDeletePhotoConfirmOpen={props.handleDeletePhotoConfirmOpen}
              handleDeleteCastingConfirmClose={props.handleDeleteCastingConfirmClose}
              handleDeleteCastingConfirmOpen={props.handleDeleteCastingConfirmOpen}
              handleModalOpen={props.handleModalOpen}
              handleActionsConfirmOpen={props.handleActionsConfirmOpen}
              createdTime={item.createdTime}
            />
          ))}
        {props.activeTab === 0
          && props.moderatedCastings.success
          && props.allCastings.success
          && props.moderatedCastings.data.length === 0 && (
          <div className="castings_empty__container">
            <div className="castings_empty">
              <Icon name="calendar-checked" />
              <p>No castings awaiting moderation</p>
            </div>
          </div>
        )}
      </div>
    )}
  </>
);

OffersView.propTypes = {
  moderatedCastings: PropTypes.object,
  activeTab: PropTypes.number,
  setActiveTab: PropTypes.func,
  allCastings: PropTypes.object,
  archivedCastings: PropTypes.object,
  declinedCastings: PropTypes.object,
  updateDataLoading: PropTypes.bool,
  acceptCasting: PropTypes.func,
  declineCasting: PropTypes.func,
  refreshAction: PropTypes.func,
  renderSphereObject: PropTypes.func,
  renderCategoriesObject: PropTypes.func,
  categories: PropTypes.object,
  category: PropTypes.string,
  setCategory: PropTypes.func,
  sortCastingsList: PropTypes.func,
  renderDataObjectName: PropTypes.func,
  castings: PropTypes.object,
  directionStr: PropTypes.string,
  editModal: PropTypes.object,
  setEditModal: PropTypes.func,
  deletePhoto: PropTypes.func,
  handleModalClose: PropTypes.func,
  handleModalOpen: PropTypes.func,
  deletePhotoConfirm: PropTypes.object,
  handleDeletePhotoConfirmOpen: PropTypes.func,
  handleDeletePhotoConfirmClose: PropTypes.func,
  handleDeleteCastingConfirmClose: PropTypes.func,
  editCasting: PropTypes.func,
  handleActionsConfirmOpen: PropTypes.func,
  castingActionConfirm: PropTypes.object,
};
OffersView.defaultProps = {
  moderatedCastings: {},
  setActiveTab: () => {},
  activeTab: 1,
  allCastings: {},
  archivedCastings: {},
  declinedCastings: {},
  updateDataLoading: false,
  acceptCasting: () => {},
  declineCasting: () => {},
  refreshAction: () => {},
  renderSphereObject: () => {},
  renderCategoriesObject: () => {},
  categories: {},
  category: '',
  setCategory: () => {},
  sortCastingsList: () => {},
  renderDataObjectName: () => {},
  castings: null,
  directionStr: '',
  editModal: null,
  setEditModal: () => {},
  deletePhoto: () => {},
  handleModalClose: () => {},
  handleModalOpen: () => {},
  deletePhotoConfirm: null,
  handleDeletePhotoConfirmOpen: () => {},
  handleDeletePhotoConfirmClose: () => {},
  handleDeleteCastingConfirmClose: () => {},
  editCasting: () => {},
  handleActionsConfirmOpen: () => {},
  castingActionConfirm: null,
};

export default OffersView;
